import { render, staticRenderFns } from "./BackgroundDelete.vue?vue&type=template&id=78c0db73&scoped=true&"
import script from "./BackgroundDelete.vue?vue&type=script&lang=ts&"
export * from "./BackgroundDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c0db73",
  null
  
)

export default component.exports